import React from "react";
import { useDispatch } from "react-redux";
import { Button } from "antd";
import { signOut } from "../../actions/profile";

export default function ClientAccess() {
  const dispatch = useDispatch();

  function logout() {
    dispatch(signOut());
  }

  return (
    <div className="client-access mb-30">
      <p className="mb-0">شماره موبایل شما به عنوان وکیل قبلا فعال شده است.</p>
      <p className="mb-30">
        امکان استفاده از اپ به عنوان موکل برای شما وجود ندارد!
      </p>

      <div className="submit-btn center-flex">
        <Button onClick={logout}>خروج</Button>
      </div>
    </div>
  );
}
